<template>
  <div class="img-container">
    <img v-if="!api" :src="require('@/assets/images/'+imageUrl)" :alt="altText" @load="onImgLoad">
    <img v-if="api" :src="imageUrl" :alt="altText" @load="onImgLoad">

    <Skeleton v-if="!isLoaded"></Skeleton>
  </div>
</template>

<script>
import Skeleton from '@/components/Skeleton.vue'

export default {
  name: 'Image',
  components: {
    Skeleton
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    altText: {
      type: String,
      required: true
    },
    api: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isLoaded: false
    }
  },
  methods: {
    onImgLoad () {
      this.isLoaded = true
    }
  }
}
</script>

<style scoped>
img {
  height: auto;
  max-width: 100%;
}
</style>
